<template>
    <div
        ref="tab"
        class="v-tab"
        :class="clazz"
        @click="handleClick"
    >
        <span class="v-tab__label">
            <slot />
        </span>
    </div>
</template>

<script>
export default {
    name: 'VTab',
    props: {
        value: {
            type: [String, Number],
            default: 0,
        },
    },
    data() {
        return {
            currentValue: this.value,
        };
    },
    computed: {
        clazz() {
            return [
                this.$parent.currentValue === this.currentValue ? 'is-selected' : '',
            ];
        },
        resizeNotify() {
            return this.$parent.$attrs.align === 'center' && this.$parent.showUnderline;
        },
    },
    watch: {
        value(val) {
            this.currentValue = val;
        },
    },
    created() {
        if (!this.currentValue) {
            this.currentValue = this.$parent.childrenIndex;
        }
        this.$parent.childrenIndex++;
        if (this.resizeNotify) {
            window.addEventListener('resize', this.updateUndline);
        }
    },
    updated() {
        this.updateUndline();
    },
    destroyed() {
        if (this.resizeNotify) {
            window.removeEventListener('resize', this.updateUndline);
        }
    },
    methods: {
        handleClick() {
            // 抛出change事件，让父组件决定是否切换
            this.$emit('before-change', this.currentValue, (confirmed) => {
                if (confirmed) {
                    this.$parent.currentValue = this.currentValue;
                    this.$parent.selectedTransform = 0.25;
                }
            });
        },
        updateUndline() {
            this.$nextTick(function () {
                if (this.$parent.currentValue === this.currentValue) {
                    this.$parent.selectedWidth = this.$refs.tab.offsetWidth;
                    this.$parent.selectedOffset = this.$refs.tab.offsetLeft;
                }
            });
        },
    },
};
</script>
